import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Footer.css';
import { FiMail, FiClock, FiGlobe, FiShield, FiRefreshCw } from 'react-icons/fi';
import { FaHeart, FaCoffee } from 'react-icons/fa';

const Footer = ({ toggleDonationSidebar }) => {
    return (
        <footer className="footer" itemScope itemType="http://schema.org/WPFooter">
            <div className="footer-container">
                <div className="footer-content">
                    <div className="footer-main">
                        <div className="footer-branding">
                            <Link to="/" className="footer-logo">
                                <FiMail /> Quick Inbox
                            </Link>
                            <h2 className="footer-tagline">Temporary Email Service</h2>
                            <div className="footer-description">
                                <p>
                                    Quick Inbox provides free disposable temporary email addresses to protect your privacy, 
                                    avoid spam, and keep your real inbox clean.
                                </p>
                                <p>
                                    Use our disposable email service for sign-ups, trials, and one-time verifications without risking 
                                    your primary email address. No registration required - get a free temp mail inbox in seconds.
                                </p>
                            </div>
                            <div className="footer-features">
                                <div className="footer-feature">
                                    <FiShield className="feature-icon" />
                                    <span>100% Secure</span>
                                </div>
                                <div className="footer-feature">
                                    <FiRefreshCw className="feature-icon" />
                                    <span>Auto Refresh</span>
                                </div>
                                <div className="footer-feature">
                                    <FiClock className="feature-icon" />
                                    <span>24hr Availability</span>
                                </div>
                                <div className="footer-feature">
                                    <FiGlobe className="feature-icon" />
                                    <span>Free Service</span>
                                </div>
                            </div>
                        </div>
                        
                        <div className="footer-nav">
                            <div className="footer-links-column">
                                <h3>Navigation</h3>
                                <ul>
                                    <li><Link to="/">Home</Link></li>
                                    <li><Link to="/blog">Blog</Link></li>
                                    <li><Link to="/faq">FAQ</Link></li>
                                    <li><Link to="/privacy">Privacy Policy</Link></li>
                                </ul>
                            </div>
                            
                            <div className="footer-links-column">
                                <h3>Temp Mail Guides</h3>
                                <ul>
                                    <li><Link to="/blog/what-is-temporary-disposable-email">What is Temporary Email?</Link></li>
                                    <li><Link to="/blog/how-to-create-temporary-email">Create a Temp Mail</Link></li>
                                    <li><Link to="/blog/anonymous-online-with-temp-email">Stay Anonymous Online</Link></li>
                                    <li><Link to="/blog/best-temporary-email-services">Best Email Services</Link></li>
                                </ul>
                            </div>
                            
                            <div className="footer-support">
                                <h3>Support the Project</h3>
                                <p>Quick Inbox is free to use. If you find it valuable, consider supporting the development to keep the service running.</p>
                                <button onClick={toggleDonationSidebar} className="support-button">
                                    <FaCoffee className="coffee-icon" /> Buy me a coffee
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div className="footer-bottom">
                    <div className="footer-meta">
                        <p className="seo-text">
                            Our temporary email generator creates anonymous email addresses that automatically receive messages, 
                            allowing you to view emails without revealing your identity. Perfect for testing, avoiding marketing 
                            lists, and keeping your inbox spam-free while maintaining your online privacy.
                        </p>
                        <div className="footer-text">
                            Made with <FaHeart className="heart-icon" /> by
                            <a href="https://github.com/rahul-dhar-e5609" target="_blank" rel="noopener noreferrer" className="creator-link">
                                Somebody in India
                            </a>
                        </div>
                        <div className="copyright">
                            © {new Date().getFullYear()} Quick Inbox - Temporary Email Service. All rights reserved.
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer; 